module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_nishihara-4cd984b6f270347b0d6e94ddc939cc49.jpg";